module.exports = __webpack_public_path__ + "img/km.617f4135.svg";